export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14249.2c6d2dfd.jpg";